import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewPhonenumberMonthlyCost, PermissionEnum, CrudEnum, TPhonenumberMonthlyCostSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, usePhonenumberMonthlyCosts, useOrganizations, } from '@Hooks';
import { PhonenumberMonthlyCostListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const PhonenumberMonthlyCostList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewPhonenumberMonthlyCost, TPhonenumberMonthlyCostSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const phonenumber_monthly_costs = usePhonenumberMonthlyCosts();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  useEffect(() => {
    if (!phonenumber_monthly_costs.loaded)
      return;
      
    setLoading(false);
    setRows((phonenumber_monthly_costs?.phonenumber_monthly_costs || []).map(row => ({ ...row, key: row.id, })));
    
  }, [phonenumber_monthly_costs, ]);

  const columns: ColumnsType<IPreviewPhonenumberMonthlyCost> = React.useMemo(() => {
    return PhonenumberMonthlyCostListColumns(t, navigate, false, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('PHONENUMBER_MONTHLY_COSTS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.PhonenumberMonthlyCost) ? { callback: () => navigate('/admin/phonenumber_monthly_cost/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TPhonenumberMonthlyCostSortableListCol, order: s.order as IWithListSorterProps<IPreviewPhonenumberMonthlyCost, TPhonenumberMonthlyCostSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const PhonenumberMonthlyCostListView = React.memo(withList<IPreviewPhonenumberMonthlyCost, TPhonenumberMonthlyCostSortableListCol>(PhonenumberMonthlyCostList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
